import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";
import React, { FunctionComponent } from "react";

export const EmailIcon: FunctionComponent<SvgIconProps> = (props) => (
	<SvgIcon
		viewBox="0 0 24 24"
		{...props}
	>
		<g clipPath="url(#clip0_979_376)">
			<path
				d="M20 4H4C2.895 4 2.01 4.895 2.01 6L2 18C2 19.105 2.895 20 4 20H20C21.105 20 22 19.105 22 18V6C22 4.895 21.105 4 20 4ZM20 18H4V8L12 13L20 8V18ZM12 11L4 6H20L12 11Z"
				fill="#79818F"
			/>
		</g>
		<defs>
			<clipPath id="clip0_979_376">
				<rect
					fill="white"
					height="24"
					width="24"
				/>
			</clipPath>
		</defs>
	</SvgIcon>
);

export default EmailIcon;
